/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AtticInsulationEnum = 1 | 2 | 3;

export const AtticInsulationEnum = {
    NUMBER_1: 1 as AtticInsulationEnum,
    NUMBER_2: 2 as AtticInsulationEnum,
    NUMBER_3: 3 as AtticInsulationEnum
};

